import { render, staticRenderFns } from "./BaseSettings.vue?vue&type=template&id=8bb3722c"
import script from "./BaseSettings.vue?vue&type=script&lang=js"
export * from "./BaseSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports